import { FormattedHTMLMessage } from "react-intl";

import { type VerificationService } from "../../lib/types/types";
import { assertValidSegmentName } from "../../lib/types/assertions";
import { useFlags } from "../FeatureFlags/hooks";
import { getOptions } from "../../options/options";

import { getLegacyAcceptableUploads } from "./getLegacyAcceptableUploads";

interface Props {
  verificationService: VerificationService;
}

/**
 * This was part of the legacy doc upload. It's now only used as it was exported
 * from the es6 file.
 * @deprecated
 */
const AcceptableUploadsComponent = ({ verificationService }: Props) => {
  const { segment } = verificationService.verificationResponse;
  const { subSegment } = verificationService.verificationResponse;
  const flags = useFlags();
  const { hideMilitaryFamilyAcceptableUploads } = getOptions();
  assertValidSegmentName(segment);

  const acceptableUploads = getLegacyAcceptableUploads(segment, subSegment, {
    flags,
    hideMilitaryFamilyAcceptableUploads,
  });

  if (acceptableUploads.length < 1) {
    return null;
  }

  return (
    <div className="sid-acceptable-uploads-list-block sid-l-space-top-md">
      <span className="sid-acceptable-uploads-examples">
        <strong>
          <FormattedHTMLMessage
            id="step.docUpload.acceptableUploadExamples"
            defaultMessage="Acceptable examples include:"
          />
        </strong>
      </span>
      <ul className="sid-acceptable-uploads-list">
        {acceptableUploads.map((i18nKey) => (
          <li key={i18nKey} className="sid-acceptable-uploads-list__li">
            <FormattedHTMLMessage id={i18nKey} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export { AcceptableUploadsComponent };
